module.exports = __webpack_public_path__ + "img/signup-guide-03-02.004c4dbc.png";